import type { CategoryProduct } from "@/lib/catalog";
import ProductCarousel from "@/components/feature/ProductCarousel";

interface GiftGroup {
  id: string;
  emoji: string;
  title: string;
  categories: string[];
  slug: string;
}

/**
 * Agrupa productos REALES (de la base de datos) por intención de regalo.
 * No crea productos falsos: si una categoría no tiene productos, se oculta.
 */
const GIFT_GROUPS: GiftGroup[] = [
  { id: "tech", emoji: "🎮", title: "Tecnología y gadgets", categories: ["Electrónica"], slug: "electronica" },
  { id: "moda", emoji: "👗", title: "Moda y estilo", categories: ["Moda"], slug: "moda" },
  { id: "hogar", emoji: "🏡", title: "Hogar y decoración", categories: ["Hogar"], slug: "hogar" },
  { id: "deportes", emoji: "⚽", title: "Deportes y aire libre", categories: ["Deportes"], slug: "deportes" },
];

export default function ChristmasGiftIdeas({
  products,
  featured,
}: {
  products: CategoryProduct[];
  featured: CategoryProduct[];
}) {
  const groups = GIFT_GROUPS.map((group) => ({
    ...group,
    items: products.filter((product) =>
      group.categories.includes(product.category),
    ),
  })).filter((group) => group.items.length > 0);

  const offers = featured.length > 0 ? featured : [];

  return (
    <section className="mx-auto max-w-7xl py-2">
      <div className="px-4 md:px-6">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
          <i className="ri-gift-line"></i>
          Regala con VendeYa
        </span>
        <h2 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          🎁 Ideas para regalar
        </h2>
      </div>

      {offers.length > 0 && (
        <ProductCarousel
          title="🔥 Ofertas de Navidad"
          products={offers}
        />
      )}

      {groups.map((group) => (
        <ProductCarousel
          key={group.id}
          title={`${group.emoji} ${group.title}`}
          products={group.items}
          to={`/categoria/${group.slug}`}
        />
      ))}
    </section>
  );
}